var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _c(
        "div",
        {
          staticClass: "footer__item contact-us__link",
          on: {
            click: function($event) {
              return _vm.openDialog()
            }
          }
        },
        [
          _c("md-icon", {
            staticClass: "footer__icon",
            attrs: { "md-src": "/static/img/contact_us_icon.svg" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "footer__text" }, [
            _vm._v(_vm._s(_vm.i18n.lbl_contact_us()))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDialog
        ? _c("contact-us", {
            staticClass: "contact-us__popup",
            attrs: { showDialog: _vm.showDialog },
            on: { "close-dialog": _vm.closeDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1afc3d78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afc3d78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/Footer.vue
// module id = zXJh
// module chunks = 1